import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import 'antd/dist/antd.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import AOS from 'aos';
import './About.css';
import 'aos/dist/aos.css';
import 'aos/dist/aos.js';
import '../../globalcss.css';
import meeting from '../../Images/meeting.png';
import sponser from '../../Images/sponser.png';
import pin from '../../Images/pin.png';
import team from '../../Images/team.png';
import subheader from '../../Images/subheader.jpeg';
import Navbar from '../Navbar/Navbar.js';
import Footer from '../Footer/Footer.js';
import { Row, Col } from 'antd';
import CountTo from 'react-count-to';


class Aboutus extends Component {
    constructor(props, context) {
        super(props, context);
        AOS.init();
    }
    componentDidMount() {
        // function to scrollto top
        // aradhana
        
        window.scrollTo(0, 0)
    }
    componentWillReceiveProps() {
        AOS.refresh();
    }
    render() {
        var settings = {
            dots: false,
            infinite: true,
            speed: 500,
            autoplay: true,
            slidesToShow: 1,
            slidesToScroll: 1
        };
        return (
            <div className="homecontain">
                <div className="subpageheader">
                    <Row type="flex">
                        <Col span={24}>
                            <p className="subheaderheading"> About Us </p>
                        </Col>
                    </Row>
                    <Row type="flex">
                        <Col span={24}>
                            <ul className="breadcrumb">
                                <li>
                                    <NavLink to="/home">Home</NavLink>
                                </li>
                                <li>About Us</li>
                            </ul>
                        </Col>
                    </Row>
                    <div className="navbar">
                        <Navbar />
                    </div>
                </div>
                {/* about section start */}
                <div className="aboutsection container">
                    <Row type="flex">
                        <Col span={24}>
                            <p className="mb5em">
                                Lorem ipsum dolor sit amet, voluptua iracundia disputationi an pri,
                                his utinam principes dignissim ad. Ne nec dolore oblique nusquam, cu luptatum volutpat
                                delicatissimi has. Sed ad dicam platonem, mea eros illum elitr id, ei has similique
                                constituto. Ea movet saperet rationibus sit, pri autem aliquip invidunt an. Consetetur
                                omittantur consequuntur eos et. Eleifend praesent iudicabit no mea, tollit persequeris
                                ex pri, tota splendide voluptaria in pri. Ad per tale aliquip, ei sit viris commune albucius. Eos aliquip scaevola ut, eum alii mentitum prodesset no, his ne suas atomorum.
                                Et numquam deleniti ponderum vis, quod error at mei. Novum blandit adolescens sea te.
                            </p>
                        </Col>
                    </Row>
                    <Row type="flex" justify="space-around" className="aboutflex">
                        <Col lg={{ span: 10 }} xs={{ span: 24 }}>
                            <img src={subheader} className="sliderimg" alt="About" />
                        </Col>
                        <Col lg={{ span: 10 }} xs={{ span: 24 }}>
                            <p>
                                I am text block. Click edit button to change this text. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elit tellus, luctus nec ullamcorper mattis, pulvinar dapibus leo.
                            </p>
                            <p>
                                I am text block. Click edit button to change this text. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elit tellus, luctus nec ullamcorper mattis, pulvinar dapibus leo.
                            </p>
                        </Col>
                    </Row>
                    <Row type="flex">
                        <Col span={24}>
                            <p className="mt5em">
                                Lorem ipsum dolor sit amet, voluptua iracundia disputationi an pri,
                                his utinam principes dignissim ad. Ne nec dolore oblique nusquam, cu luptatum volutpat
                                delicatissimi has. Sed ad dicam platonem, mea eros illum elitr id, ei has similique
                                constituto. Ea movet saperet rationibus sit, pri autem aliquip invidunt an. Consetetur
                                omittantur consequuntur eos et.
                            </p>
                        </Col>
                    </Row>
                </div>
                {/* about section End */}

                {/* our services section start */}
                <div className="ourservice container">
                    <Row type="flex" justify="center">
                        <Col span={24}>
                            <h1>Our Service</h1>
                            <h4 className="sub_title">What you will learn and the benefits ?</h4>
                        </Col>
                    </Row>
                    <div className="countersection">
                        <Row type="flex" justify="space-around">
                            <Col lg={{ span: 6 }} xs={{ span: 12 }}>
                                <div className="tapmenow bg_white">
                                    <div className="top">
                                        <img src={meeting} alt="profile" className="social_myspace" />
                                        <CountTo to={1535} speed={3535} className="number" />
                                        <div className="name">PARTICIPANT</div>
                                    </div>

                                </div>
                            </Col>
                            <Col lg={{ span: 6 }} xs={{ span: 12 }}>
                                <div className="tapmenow bg_white">
                                    <div className="top">
                                        <img src={pin} alt="profile" className="social_myspace"/>
                                        <CountTo to={333} speed={3535} className="number" />
                                        <div className="name">VENUES</div>
                                    </div>

                                </div>
                            </Col>
                            <Col lg={{ span: 6 }} xs={{ span: 12 }}>
                                <div className="tapmenow bg_white">
                                    <div className="top">
                                        <img src={sponser} alt="profile" className="social_myspace"/>
                                        <CountTo to={120} speed={3535} className="number" />
                                        <div className="name">SPONSORS</div>
                                    </div>
                                </div>
                            </Col>
                            <Col lg={{ span: 6 }} xs={{ span: 12 }}>
                                <div className="tapmenow bg_white no_border">
                                    <div className="top">
                                        <img src={team} alt="profile" className="social_myspace" />
                                        <CountTo to={267} speed={3535} className="number" />
                                        <div className="name">MEMBER</div>
                                    </div>

                                </div>
                            </Col>
                        </Row>
                    </div>
                    <Row type="flex">
                        <Col span={24}>
                            <p>
                                Lorem ipsum dolor sit amet, voluptua iracundia disputationi an pri,
                                his utinam principes dignissim ad. Ne nec dolore oblique nusquam, cu luptatum volutpat
                                delicatissimi has. Sed ad dicam platonem, mea eros illum elitr id, ei has similique
                                constituto. Ea movet saperet rationibus sit, pri autem aliquip invidunt an. Consetetur
                                omittantur consequuntur eos et.
                            </p>
                        </Col>
                    </Row>
                </div>
                {/* our service section end */}


                <Footer></Footer>
            </div>
        );
    }
}

export default Aboutus;


// WEBPACK FOOTER //
// ./src/Component/About/About.js